/* eslint-disable import/no-anonymous-default-export */
export default {
  mutation: `mutation createBlocks($blocks: [CreateBlockData]) {
        createBlocks(blocks: $blocks)
    }`,
};
